import BlCalloutMv from './BlCalloutMv.vue'

BlCalloutMv.install = function(Vue) {
  Vue.component(BlCalloutMv.name, BlCalloutMv)
}

export default BlCalloutMv
